import { Profile, MappingPair } from '@dynamic-mapper/mapper';
import { AppointmentDTO } from 'src/app/domain/customer/appointment.dto';
import { Appointment } from '../../models/customer/appointment.model';

export class AppointmentProfile extends Profile {
    static readonly DtoToDomain = new MappingPair<Appointment,AppointmentDTO>();

    constructor(){
        super();
        
        this.createMap(AppointmentProfile.DtoToDomain,{
            pageNumber:opt => opt.mapFrom(src => src.pageNumber),
            pageSize:opt => opt.mapFrom(src => src.pageSize),
            totalItems:opt  => opt.mapFrom(src => src.totalItems),
            filterId: opt => opt.mapFrom(src => src.filterId),
            list:opt => opt.mapFrom(src => src.list),
        })
    }
}